import React from 'react';
import TextFieldGroup from '../common/textFieldGroup';
import { isEmpty } from 'lodash';
import { PropTypes } from 'prop-types';

const LoginForm = ({ className, formErrors, serverError, identifier, password, isLoading, onChange, onSubmit, onForgotPassword }) => {
	return (
		<form onSubmit={onSubmit} autoComplete="on" className={`login-form ${className}`}>
			{serverError && !isEmpty(serverError) && <div className="alert alert-danger">{`${serverError}`}</div>}

			<TextFieldGroup
				field="identifier"
				label="Username / Email"
				value={identifier}
				error={formErrors.identifier}
				onChange={onChange}
				type="text"
			/>

			<TextFieldGroup
				field="password"
				label="Password"
				value={password}
				error={formErrors.password}
				onChange={onChange}
				type="password"
			/>

			<button type="submit" className="btn btn-primary btn-lg btn-full-width" disabled={isLoading}>Login</button>

			<p className="message text-center">
				<button className="btn btn-link" onClick={onForgotPassword}>Forgot password?</button>
			</p>
		</form>
	);
};

LoginForm.propTypes = {
	className: PropTypes.string, 
	formErrors: PropTypes.object, 
	serverError: PropTypes.string,
	identifier: PropTypes.string, 
	password: PropTypes.string, 
	isLoading: PropTypes.bool, 
	onChange: PropTypes.func, 
	onSubmit: PropTypes.func.isRequired, 
	onForgotPassword: PropTypes.func
};

export default LoginForm;